import { useReducedMotion } from 'animations/useReducedMotion';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CARD_SELECTORS = '.admin-motion-card, .card, .dashboard-metric-card';

/**
 * Stagger-animates card surfaces after route changes (GSAP, same pattern as Dashboard).
 */
export function useAdminCardEntrance(delayMs = 120) {
    const location = useLocation();
    const reducedMotion = useReducedMotion();

    useEffect(() => {
        if (reducedMotion) {
            return;
        }
        let cancelled = false;
        const timer = window.setTimeout(async () => {
            const { gsap } = await import('gsap');
            if (cancelled) {
                return;
            }
            const cards = document.querySelectorAll(CARD_SELECTORS);
            if (cards.length === 0) {
                return;
            }
            gsap.fromTo(
                cards,
                { opacity: 0, y: 20, rotateX: 6 },
                {
                    opacity: 1,
                    y: 0,
                    rotateX: 0,
                    duration: 0.42,
                    stagger: 0.05,
                    ease: 'power2.out',
                    clearProps: 'transform',
                }
            );
        }, delayMs);
        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [location.pathname, reducedMotion, delayMs]);
}
